import React, { useState } from 'react';
import { Section } from 'jbc-front/components/Form';
import Button from 'jbc-front/components/Button';

import styles from './Agreement.scss';
import Axios from 'axios';

import { useTranslation } from 'react-i18next';

const Agreement = () => {
  const [isBottom, setIsBottom] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { t } = useTranslation();

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.offsetHeight;
    if (bottom) {
      setIsBottom(true);
    }
  };
  const onSubmit = () => {
    setIsSubmitting(true);
    Axios.put('/users/consents/pdpa_consent', { pdpa_consent: true })
      .then(res => {
        if (res.status == 200)
          window.location.replace('/dashboards')
      })
  };
  return (
    <div className="l-flex">
      <div className="u-mt30">
        <Section title={t('features.PDPAPage.title')} style={{ maxWidth: '1000px' }}>
          <div className={styles.detail} name={'detail'} onScroll={handleScroll}>
            <h2 className={styles.title} >{t('features.PDPAPage.title')}</h2>

            <div className={styles.section} id={"section1"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section1.header')}</h3>
              <p className={styles.subTopic}>{t('features.PDPAPage.section1.text')}</p>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section1.topic1.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section2"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section2.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section2.topic1.text')} </li>
                <li>{t('features.PDPAPage.section2.topic2.text')} </li>
                <li>{t('features.PDPAPage.section2.topic3.text')} </li>
                <li>{t('features.PDPAPage.section2.topic4.text')} </li>
              </ol>
            </div>

            <div className={styles.section} id={"section3"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section3.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section3.topic1.text')} </li>
                <li>{t('features.PDPAPage.section3.topic2.text')} </li>
                <li>{t('features.PDPAPage.section3.topic3.text')} </li>
                <li>{t('features.PDPAPage.section3.topic4.text')} </li>
                <li>{t('features.PDPAPage.section3.topic5.text')} </li>
              </ol>
            </div>

            <div className={styles.section} id={"section4"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section4.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section4.topic1.text')} </li>
                <li>{t('features.PDPAPage.section4.topic2.text')} </li>
              </ol>
            </div>

            <div className={styles.section} id={"section5"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section5.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section5.topic1.text')} </li>
                <li>{t('features.PDPAPage.section5.topic2.text')} </li>
              </ol>
            </div>

            <div className={styles.section} id={"section6"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section6.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section6.topic1.text')} </li>
                <li>{t('features.PDPAPage.section6.topic2.text')} </li>
                <li>{t('features.PDPAPage.section6.topic3.text')} </li>
                <li>{t('features.PDPAPage.section6.topic4.text')} </li>
              </ol>
            </div>

            <div className={styles.section} id={"section7"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section7.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section7.topic1.text')} </li>
                <li>{t('features.PDPAPage.section7.topic2.text')} </li>
                <li>{t('features.PDPAPage.section7.topic3.text')} </li>
                <li>{t('features.PDPAPage.section7.topic4.text')} </li>
                <li>{t('features.PDPAPage.section7.topic5.text')} </li>
              </ol>
            </div>

            <div className={styles.section} id={"section8"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section8.header')} </h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section8.topic1.text')} </li>
                <li>{t('features.PDPAPage.section8.topic2.text')} </li>
              </ol>
            </div>

            <div className={styles.section} id={"section9"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section9.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section9.topic1.text')}</li>
                <li>{t('features.PDPAPage.section9.topic2.text')}
                  <p className={styles.subTopic}>{t('features.PDPAPage.section9.topic2.subTopic1')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section9.topic2.subTopic2')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section9.topic2.subTopic3')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section9.topic2.subTopic4')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section9.topic2.subTopic5')}</p>
                </li>
                <li>{t('features.PDPAPage.section9.topic3.text')}</li>
                <li>{t('features.PDPAPage.section9.topic4.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section10"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section10.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section10.topic1.text')}</li>
                <li>{t('features.PDPAPage.section10.topic2.text')}</li>
                <li>{t('features.PDPAPage.section10.topic3.text')}</li>
                <li>{t('features.PDPAPage.section10.topic4.text')}</li>
                <li>{t('features.PDPAPage.section10.topic5.text')}</li>
                <li>{t('features.PDPAPage.section10.topic6.text')}</li>
                <li>{t('features.PDPAPage.section10.topic7.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section11"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section11.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section11.topic1.text')}</li>
                <li>{t('features.PDPAPage.section11.topic2.text')}</li>
                <li>{t('features.PDPAPage.section11.topic3.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section12"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section12.header')}</h3>
              <p className={styles.subTopic}>{t('features.PDPAPage.section12.text')}</p>
            </div>

            <div className={styles.section} id={"section13"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section13.header')}</h3>
              <p className={styles.subTopic}>{t('features.PDPAPage.section13.text')}</p>
            </div>

            <div className={styles.section} id={"section14"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section14.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section14.topic1.text')}</li>
                <li>{t('features.PDPAPage.section14.topic2.text')}</li>
                <li>{t('features.PDPAPage.section14.topic3.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section15"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section15.header')}</h3>
              <ol className={styles.topic}>
                <li>
                  {t('features.PDPAPage.section15.topic1.text')}
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic1')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic2')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic3')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic4')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic5')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic6')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic7')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic8')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic9')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic10')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic11')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic12')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic13')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic14')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section15.topic1.subTopic15')}</p>
                </li>
                <li>{t('features.PDPAPage.section15.topic2.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section16"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section16.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section16.topic1.text')}</li>
                <li>{t('features.PDPAPage.section16.topic2.text')}</li>

              </ol>
            </div>

            <div className={styles.section} id={"section17"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section17.header')}</h3>
              <ol className={styles.topic}>
                <li>
                  {t('features.PDPAPage.section17.topic1.text')}
                  <p className={styles.subTopic}>{t('features.PDPAPage.section17.topic1.subTopic1')}</p>
                  <div className={styles.subTopic}>
                    {t('features.PDPAPage.section17.topic1.subTopic2.text')}
                    <p className={styles.ml10}>{t('features.PDPAPage.section17.topic1.subTopic2[1]')}</p>
                    <p className={styles.ml10}>{t('features.PDPAPage.section17.topic1.subTopic2[2]')}</p>
                  </div>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section17.topic1.subTopic3')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section17.topic1.subTopic4')}</p>
                  <div className={styles.subTopic}>
                    {t('features.PDPAPage.section17.topic1.subTopic5.text')}
                    <p className={styles.ml10}>{t('features.PDPAPage.section17.topic1.subTopic5[1]')}</p>
                    <p className={styles.ml10}>{t('features.PDPAPage.section17.topic1.subTopic5[2]')}</p>
                    <p className={styles.ml10}>{t('features.PDPAPage.section17.topic1.subTopic5[3]')}</p>
                    <p className={styles.ml10}>{t('features.PDPAPage.section17.topic1.subTopic5[4]')}</p>
                    <p className={styles.ml10}>{t('features.PDPAPage.section17.topic1.subTopic5[5]')}</p>
                  </div>
                </li>
                <li>{t('features.PDPAPage.section17.topic2.text')}</li>
                <li>{t('features.PDPAPage.section17.topic3.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section18"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section18.header')}</h3>
              <ol className={styles.topic}>
                <li>
                  {t('features.PDPAPage.section18.topic1.text')}
                  <p className={styles.subTopic}>{t('features.PDPAPage.section18.topic1.subTopic1')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section18.topic1.subTopic2')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section18.topic1.subTopic3')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section18.topic1.subTopic4')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section18.topic1.subTopic5')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section18.topic1.subTopic6')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section18.topic1.subTopic7')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section18.topic1.subTopic8')}</p>
                </li>
                <li>{t('features.PDPAPage.section18.topic2.text')}</li>
                <li>{t('features.PDPAPage.section18.topic3.text')}</li>
              </ol>
            </div>


            <div className={styles.section} id={"section19"}>

              <h3 className={styles.header}>{t('features.PDPAPage.section19.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section19.topic1.text')}</li>
                <li>
                  {t('features.PDPAPage.section19.topic2.text')}
                  <p className={styles.subTopic}>{t('features.PDPAPage.section19.topic2.subTopic1')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section19.topic2.subTopic2')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section19.topic2.subTopic3')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section19.topic2.subTopic4')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section19.topic2.subTopic5')}</p>
                  <p className={styles.subTopic}>{t('features.PDPAPage.section19.topic2.subTopic6')}</p>
                </li>
                <li>{t('features.PDPAPage.section19.topic3.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section20"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section20.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section20.topic1.text')}</li>
                <li>{t('features.PDPAPage.section20.topic2.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section21"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section21.header')}</h3>
              <p className={styles.subTopic}>{t('features.PDPAPage.section21.text')}</p>
            </div>

            <div className={styles.section} id={"section22"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section22.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section22.topic1.text')}</li>
                <li>{t('features.PDPAPage.section22.topic2.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section23"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section23.header')}</h3>
              <ol className={styles.topic}>
                <li>{t('features.PDPAPage.section23.topic1.text')}</li>
                <li>{t('features.PDPAPage.section23.topic2.text')}</li>
              </ol>
            </div>

            <div className={styles.section} id={"section24"}>
              <h3 className={styles.header}>{t('features.PDPAPage.section24.header')}</h3>
              <p className={styles.subTopic}>{t('features.PDPAPage.section24.text')}</p>
            </div>
          </div>
          <div className={styles.input}>
            <label className="input-label">
              <input
                type="checkbox"
                name='checkbox1'
                className="m-checkbox-input"
                checked={agreed}
                disabled={!isBottom}
                onChange={() => setAgreed((prev) => !prev)}
              />
              <span className="m-checkbox-parts">I agree to the terms and conditions</span>
            </label>
          </div>
          <div className={styles.button}>
            <Button primary disabled={!agreed} onClick={onSubmit} disabledReason="Please confirm">
              Agree
            </Button>
          </div>
        </Section>
      </div>
    </div>
  );
};
export default Agreement;
